import { render, staticRenderFns } from "./FirebaseRealtimeDb.vue?vue&type=template&id=82fe012c"
import script from "./FirebaseRealtimeDb.vue?vue&type=script&lang=js"
export * from "./FirebaseRealtimeDb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports